module.exports = __webpack_public_path__ + "static/media/CarouselImage.01aec5af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/CarouselImage.jpg
// module id = 351
// module chunks = 0